import { atom } from 'recoil';
import { StatusSetItem } from 'modules/layout/types/statusSetItem';

enum StateKey {
  CandidateRejectionModal = 'CandidateRejectionModal',
  CandidateShortlistingModal = 'CandidateShortlistingModal'
}

export const candidateRejectionModalAtom = atom<{
  isOpen: boolean;
  candidateIds: string[];
  candidateBatchId: string | undefined;
}>({
  key: StateKey.CandidateRejectionModal,
  default: {
    isOpen: false,
    candidateIds: [],
    candidateBatchId: undefined
  }
});

export const candidateShortlistingModalAtom = atom<{
  isOpen: boolean;
  candidateIds: string[];
  candidateBatchId: string | undefined;
}>({
  key: StateKey.CandidateShortlistingModal,
  default: {
    isOpen: false,
    candidateIds: [],
    candidateBatchId: undefined
  }
});

export const statusSetAtom = atom<StatusSetItem | null>({
  key: 'statusSet',
  default: null
});
